export default __webpack_public_path__ + "static/media/random-v-2.419a03a5.jpg";